const googleJobTypeReducer = (state = [], action) => {
    switch (action.type) {
    case 'FETCH_GOOGLE_JOB_TYPES':
        return action.payload;
    default:
        return state;
    }
};

export default googleJobTypeReducer;